import * as actionTypes from "./actionTypes";
// remove this
export const updateMyPasswordStart = () => {
  return {
    type: actionTypes.UPDATE_MY_PASSWORD_START,
  };
};
// remove this
export const updateMyPasswordSuccess = (response) => {
  return {
    type: actionTypes.UPDATE_MY_PASSWORD_SUCCESS,
    response,
  };
};
// remove this
export const updateMyPasswordFail = (error) => {
  return {
    type: actionTypes.UPDATE_MY_PASSWORD_FAIL,
    error: error,
  };
};

/**
 * Returns Redux Saga function that dispatches UPDATE_SUCCESS action
 * and (conditionally) UPDATE_SUCCESS action
 * @function updateMyPassword
 * @param {string} userData - updateMyPassword.
 * @returns {function} - Redux Saga function.
 */
// remove this
export const updateMyPassword = (userData) => {
  return {
    type: actionTypes.UPDATE_MY_PASSWORD,
    userData: userData,
  };
};
